<template>

    <svg version="1.2"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         overflow="visible"
         preserveAspectRatio="none"
         viewBox="0 0 24 24"
         width="18"
         height="18">
        <g>
            <path xmlns:default="http://www.w3.org/2000/svg" id="male" d="M17.33,9.88c0-1.1-0.9-2-2-2H8.67c-1.1,0-2,0.9-2,2v4.33c0,0.55,0.45,1,1,1s1-0.45,1-1v-3.66h0.66v9.5  c0.06,0.64,0.63,1.12,1.27,1.06c0.56-0.05,1-0.5,1.06-1.06v-4.83h0.67v4.83c0.06,0.64,0.63,1.12,1.27,1.06  c0.56-0.05,1-0.5,1.06-1.06v-9.5h0.67v3.66c0,0.55,0.45,1,1,1c0.55,0,1-0.45,1-1V9.88L17.33,9.88z M14.33,5.22  c0-1.29-1.04-2.33-2.33-2.33l0,0c-1.29,0-2.33,1.04-2.33,2.33l0,0c0,1.29,1.04,2.33,2.33,2.33S14.33,6.51,14.33,5.22L14.33,5.22z" style="fill: rgb(18, 18, 18);" vector-effect="non-scaling-stroke"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "MaleSVG"
    }
</script>

<style scoped>

</style>